// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dc-case-form-wrapper {
  background: #f9fafb;
  padding: 2rem;
}
.dc-case-form-wrapper .fetch-details-btn {
  padding: 0.5rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 120px;
  transition: background-color 0.2s;
}
.dc-case-form-wrapper .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.dc-case-form-wrapper .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.dc-case-form-wrapper .rem-div-btn,
.dc-case-form-wrapper .add-div-btn {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}
.dc-case-form-wrapper .court-remove-case {
  padding: 0.5rem 1rem;
  background-color: #e74c3c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.dc-case-form-wrapper .court-remove-case:hover {
  background-color: #dc2626;
}
.dc-case-form-wrapper .court-add-case {
  padding: 0.5rem 1rem;
  background-color: #5cb85c;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.dc-case-form-wrapper .court-add-case:hover {
  background-color: #16a34a;
}
@media (max-width: 768px) {
  .dc-case-form-wrapper {
    padding: 1rem;
  }
}

.court-ref-fetch-section {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin: 0 auto 1rem auto;
}
.court-ref-fetch-section .fetch-section-title {
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.court-ref-fetch-section .fetch-input-group {
  display: flex;
  gap: 1rem;
  align-items: flex-end;
}
@media (max-width: 768px) {
  .court-ref-fetch-section .fetch-input-group {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }
}
.court-ref-fetch-section .fetch-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.court-ref-fetch-section .fetch-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.court-ref-fetch-section .fetch-input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
}
.court-ref-fetch-section .fetch-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.court-ref-fetch-section .fetch-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.court-ref-fetch-section .fetch-input::placeholder {
  color: #9ca3af;
}
.court-ref-fetch-section .fetch-details-btn {
  padding: 0.75rem 1.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  min-width: 140px;
  transition: background-color 0.2s;
  height: fit-content;
}
.court-ref-fetch-section .fetch-details-btn:hover:not(:disabled) {
  background-color: #0052a3;
}
.court-ref-fetch-section .fetch-details-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.court-ref-fetch-section .fetch-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
@media (max-width: 768px) {
  .court-ref-fetch-section .fetch-details-btn {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .court-ref-fetch-section {
    padding: 1rem;
    margin-bottom: 1.5rem;
  }
}

.dc-case-form-header {
  text-align: center;
  margin-bottom: 2rem;
}
.dc-case-form-header .dc-case-form-title {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #374151;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  .dc-case-form-header .dc-case-form-title {
    font-size: 1.25rem;
  }
}
.dc-case-form-header .dc-case-form-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 400;
}

.dc-case-form {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin: auto;
}
@media (max-width: 768px) {
  .dc-case-form {
    padding: 1rem;
    margin: 1rem;
  }
}

.dc-section {
  margin-bottom: 1.5rem;
}
.dc-section:last-child {
  margin-bottom: 0;
}

.dc-section-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .dc-section-title {
    font-size: 1rem;
  }
}

.dc-subsection {
  background: #f9fafb;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease-in-out;
}
.dc-subsection.collapsed {
  padding: 0.75rem 1rem;
}
.dc-subsection:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .dc-subsection {
    padding: 0.75rem;
  }
}

.summary-view {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.summary-view .summary-details {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 180px);
}
.summary-view .summary-details .summary-item {
  display: flex;
  gap: 0.35rem;
}
.summary-view .summary-details .summary-label {
  color: #6b7280;
  font-weight: 500;
}
.summary-view .summary-details .summary-value {
  color: #111827;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.summary-view .summary-actions {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.summary-view .summary-actions .edit-btn {
  padding: 0.5rem 1rem;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.summary-view .summary-actions .edit-btn:hover {
  background-color: #2563eb;
}

.dc-field-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.dc-field-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .dc-field-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}

.dc-field-group {
  margin-bottom: 1rem;
}
.dc-field-group:last-child {
  margin-bottom: 0;
}

.dc-input-wrapper {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.dc-input-wrapper:last-child {
  margin-bottom: 0;
}

.dc-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.dc-label .user-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}

.dc-input,
.dc-textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
}
.dc-input:focus,
.dc-textarea:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.dc-input:hover:not(:focus),
.dc-textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.dc-input::placeholder,
.dc-textarea::placeholder {
  color: #9ca3af;
}
.dc-input:disabled,
.dc-textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}

.dc-input {
  height: 2.5rem;
}
.dc-input.dc-input-full {
  grid-column: 1/-1;
}
.dc-input.dc-input-date {
  cursor: pointer;
}
.dc-input.dc-input-date::-webkit-calendar-picker-indicator {
  cursor: pointer;
  opacity: 0.6;
}
.dc-input.dc-input-date::-webkit-calendar-picker-indicator:hover {
  opacity: 0.8;
}

select.dc-input {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}

.dc-textarea {
  min-height: 4rem;
  resize: vertical;
  line-height: 1.5;
  font-family: inherit;
}

.dc-empty-state {
  text-align: center;
  padding: 2rem;
  background: #f9fafb;
  border-radius: 0.375rem;
  border: 2px dashed #e5e7eb;
}

.dc-empty-text {
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}

.dc-submit-section-form {
  display: flex;
  justify-content: end;
  margin-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .dc-submit-section-form {
    flex-direction: column;
  }
}
.dc-submit-section-form .submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin-top: 1rem;
  display: block;
}
.dc-submit-section-form .submit-btn:hover {
  background-color: #005a9a;
}
.dc-submit-section-form .submit-btn:focus {
  outline: none;
}
.dc-submit-section-form .submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
@media (max-width: 768px) {
  .dc-submit-section-form .submit-btn {
    width: 100%;
    margin-top: 1rem;
  }
}

.dc-submit-section {
  position: fixed;
  bottom: 2rem;
  left: 87.7%;
  transform: translateX(-145%);
  z-index: 1000;
}
.dc-submit-section.hidden {
  opacity: 0;
  pointer-events: none;
}
@media (max-width: 768px) {
  .dc-submit-section {
    bottom: 1rem;
    left: 1rem;
    right: 1rem;
    transform: none;
  }
}
.dc-submit-section .dc-submit-btn {
  padding: 0.75rem 1rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 150px;
  margin: 1.5rem auto 0;
  display: block;
}
.dc-submit-section .dc-submit-btn:hover {
  background-color: #005a9a;
}
.dc-submit-section .dc-submit-btn:focus {
  outline: none;
}
.dc-submit-section .dc-submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}
.dc-submit-section .dc-submit-btn:disabled:hover {
  transform: none;
}
@media (max-width: 768px) {
  .dc-submit-section .dc-submit-btn {
    width: 100%;
    border-radius: 25px;
    min-width: unset;
    font-size: 0.95rem;
    padding: 0.875rem 1.25rem;
  }
}

@media (max-width: 768px) {
  .dc-field-row {
    flex-direction: column;
    gap: 0.5rem;
  }
  .dc-subsection {
    padding: 0.75rem;
  }
  .dc-input,
  .dc-textarea {
    font-size: 0.875rem;
  }
}
@media (max-width: 480px) {
  .dc-case-form-wrapper {
    padding: 0.5rem;
  }
  .dc-case-form {
    padding: 1rem;
    margin: 0.5rem;
  }
  .dc-case-form-header .dc-case-form-title {
    font-size: 1.125rem;
  }
  .dc-input,
  .dc-textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .dc-submit-btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }
}
.dc-case-form {
  animation: dc-fade-in 0.3s ease-out;
}

@keyframes dc-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media print {
  .dc-case-form-wrapper {
    background: white;
    padding: 0;
  }
  .dc-case-form {
    box-shadow: none;
    border: 1px solid #000;
  }
  .dc-submit-section,
  .rem-div-btn,
  .add-div-btn {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/forms/DistrictCourtCaseForm/DistrictCourtCaseForm.scss"],"names":[],"mappings":"AACA;EAEE,mBAAA;EACA,aAAA;AADF;AAGE;EACE,oBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;AADJ;AAGI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AADN;AAII;EACE,aAAA;EACA,6CAAA;AAFN;AAME;;EAEE,aAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOI;EACE,yBAAA;AALN;AASE;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAYE;EApEF;IAqEI,aAAA;EATF;AACF;;AAYA;EACE,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,wBAAA;AATF;AAWE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AATJ;AAYE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AAVJ;AAYI;EALF;IAMI,sBAAA;IACA,oBAAA;IACA,YAAA;EATJ;AACF;AAYE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAVJ;AAaE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAXJ;AAcE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AAZJ;AAcI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAZN;AAeI;EACE,qBAAA;AAbN;AAgBI;EACE,cAAA;AAdN;AAkBE;EACE,uBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,mBAAA;AAhBJ;AAkBI;EACE,yBAAA;AAhBN;AAmBI;EACE,yBAAA;EACA,mBAAA;EACA,YAAA;AAjBN;AAoBI;EACE,aAAA;EACA,6CAAA;AAlBN;AAqBI;EA7BF;IA8BI,WAAA;EAlBJ;AACF;AAqBE;EAvGF;IAwGI,aAAA;IACA,qBAAA;EAlBF;AACF;;AAsBA;EACE,kBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;AAnBJ;AAqBI;EANF;IAOI,kBAAA;EAlBJ;AACF;AAqBE;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AAnBJ;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wCAAA;EACA,YAAA;AArBF;AAuBE;EAVF;IAWI,aAAA;IACA,YAAA;EApBF;AACF;;AAwBA;EACE,qBAAA;AArBF;AAuBE;EACE,gBAAA;AArBJ;;AAyBA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAtBF;AAwBE;EARF;IASI,eAAA;EArBF;AACF;;AAwBA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;AArBF;AAwBE;EACE,qBAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AA0BE;EAjBF;IAkBI,gBAAA;EAvBF;AACF;;AA2BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AAxBF;AA0BE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,6BAAA;AAzBJ;AA2BI;EACI,aAAA;EACA,YAAA;AAzBR;AA4BI;EACE,cAAA;EACA,gBAAA;AA1BN;AA6BI;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AA3BN;AA+BE;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AA7BJ;AA+BI;EACE,oBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;AA7BN;AA+BM;EACE,yBAAA;AA7BR;;AAqCA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,gBAAA;AAlCJ;AAqCE;EATF;IAUI,sBAAA;IACA,WAAA;EAlCF;AACF;;AAqCA;EACE,mBAAA;AAlCF;AAoCE;EACE,gBAAA;AAlCJ;;AAuCA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AApCF;AAsCE;EACE,gBAAA;AApCJ;;AAwCA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AArCF;AAsCE;EACE,cAAA;EACA,oBAAA;AApCJ;;AAwCA;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AArCF;AAuCE;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApCJ;AAuCE;;EACE,qBAAA;AApCJ;AAuCE;;EACE,cAAA;AApCJ;AAuCE;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AApCJ;;AAwCA;EACE,cAAA;AArCF;AAuCE;EACE,iBAAA;AArCJ;AAwCE;EACE,eAAA;AAtCJ;AAwCI;EACE,eAAA;EACA,YAAA;AAtCN;AAwCM;EACE,YAAA;AAtCR;;AA+CA;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AA5CF;;AA+CA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AA5CF;;AAgDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0BAAA;AA7CF;;AAgDA;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;AA7CF;;AAgDA;EACE,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,6BAAA;AA7CF;AA+CE;EANF;IAOI,sBAAA;EA5CF;AACF;AA8CE;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA5CJ;AA8CI;EACE,yBAAA;AA5CN;AAmDI;EACE,aAAA;AAjDN;AAqDI;EACE,YAAA;EACA,mBAAA;AAnDN;AAsDI;EA/BF;IAgCI,WAAA;IACA,gBAAA;EAnDJ;AACF;;AAwDA;EASE,eAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;AA7DF;AAgEE;EACE,UAAA;EACA,oBAAA;AA9DJ;AAiEE;EArBF;IAsBI,YAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;EA9DF;AACF;AAgEE;EACE,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AA9DJ;AAgEI;EACE,yBAAA;AA9DN;AAwEI;EACE,aAAA;AAtEN;AA0EI;EACE,YAAA;EACA,mBAAA;EACA,eAAA;AAxEN;AA0EM;EAEE,eAAA;AAzER;AA8EI;EAzCF;IA0CI,WAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;EA3EJ;AACF;;AAmHA;EACE;IACE,sBAAA;IACA,WAAA;EAhHF;EAmHA;IACE,gBAAA;EAjHF;EAoHA;;IAEE,mBAAA;EAlHF;AACF;AAqHA;EACE;IACE,eAAA;EAnHF;EAsHA;IACE,aAAA;IACA,cAAA;EApHF;EAuHA;IACE,mBAAA;EArHF;EAwHA;;IAEE,iBAAA;IACA,oBAAA;EAtHF;EAyHA;IACE,yBAAA;IACA,oBAAA;EAvHF;AACF;AA2HA;EACE,mCAAA;AAzHF;;AA4HA;EACE;IACE,UAAA;IACA,2BAAA;EAzHF;EA4HA;IACE,UAAA;IACA,wBAAA;EA1HF;AACF;AA8HA;EACE;IACE,iBAAA;IACA,UAAA;EA5HF;EA+HA;IACE,gBAAA;IACA,sBAAA;EA7HF;EAgIA;;;IAGE,aAAA;EA9HF;AACF","sourcesContent":["// Main Container\n.dc-case-form-wrapper {\n  // min-height: 100vh;\n  background: #f9fafb;\n  padding: 2rem;\n\n  .fetch-details-btn {\n    padding: 0.5rem 1rem;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n    min-width: 120px;\n    transition: background-color 0.2s;\n\n    &:disabled {\n      background-color: #9ca3af;\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n\n  .rem-div-btn,\n  .add-div-btn {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 0.5rem;\n  }\n  \n  .court-remove-case {\n    padding: 0.5rem 1rem;\n    background-color: #e74c3c;\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #dc2626;\n    }\n  }\n\n  .court-add-case {\n    padding: 0.5rem 1rem;\n    background-color: #5cb85c;\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #16a34a;\n    }\n  }\n\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n}\n\n.court-ref-fetch-section {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  padding: 1.5rem;\n  margin: 0 auto 1rem auto;\n\n  .fetch-section-title {\n    font-size: 1rem;\n    color: #374151;\n    font-weight: 500;\n    margin: 0 0 1rem 0;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #e5e7eb;\n  }\n\n  .fetch-input-group {\n    display: flex;\n    gap: 1rem;\n    align-items: flex-end;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      align-items: stretch;\n      gap: 0.75rem;\n    }\n  }\n\n  .fetch-input-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .fetch-label {\n    display: block;\n    margin-bottom: 0.5rem;\n    font-weight: 500;\n    font-size: 0.875rem;\n    color: #374151;\n  }\n\n  .fetch-input {\n    width: 100%;\n    padding: 0.75rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    color: #374151;\n    background: #ffffff;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n    &:hover:not(:focus) {\n      border-color: #9ca3af;\n    }\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n  }\n\n  .fetch-details-btn {\n    padding: 0.75rem 1.5rem;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n    white-space: nowrap;\n    min-width: 140px;\n    transition: background-color 0.2s;\n    height: fit-content;\n\n    &:hover:not(:disabled) {\n      background-color: #0052a3;\n    }\n\n    &:disabled {\n      background-color: #9ca3af;\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    margin-bottom: 1.5rem;\n  }\n}\n\n// Header Section\n.dc-case-form-header {\n  text-align: center;\n  margin-bottom: 2rem;\n\n  .dc-case-form-title {\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    color: #374151;\n    font-size: 1.3rem;\n\n    @media (max-width: 768px) {\n      font-size: 1.25rem;\n    }\n  }\n\n  .dc-case-form-subtitle {\n    font-size: 0.875rem;\n    color: #6b7280;\n    font-weight: 400;\n  }\n}\n\n// Form Container\n.dc-case-form {\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem;\n  background-color: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  margin: auto;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    margin: 1rem;\n  }\n}\n\n// Section Styling\n.dc-section {\n  margin-bottom: 1.5rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.dc-section-title {\n  font-size: 1.1rem;\n  font-weight: 500;\n  color: #374151;\n  margin: 0 0 1rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e5e7eb;\n\n  @media (max-width: 768px) {\n    font-size: 1rem;\n  }\n}\n\n.dc-subsection {\n  background: #f9fafb;\n  border-radius: 0.375rem;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  border: 1px solid #f3f4f6;\n  transition: all 0.3s ease-in-out; // <-- Added transition\n\n  // <-- Added collapsed state -->\n  &.collapsed {\n    padding: 0.75rem 1rem;\n  }\n  \n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 768px) {\n    padding: 0.75rem;\n  }\n}\n\n// <-- ADD THIS ENTIRE BLOCK -->\n.summary-view {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  gap: 1rem;\n\n  .summary-details {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    flex-wrap: wrap;\n    font-size: 0.875rem;\n    // For single-line text summaries\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: calc(100% - 180px); // Adjust based on button widths\n\n    .summary-item {\n        display: flex;\n        gap: 0.35rem;\n    }\n\n    .summary-label {\n      color: #6b7280;\n      font-weight: 500;\n    }\n\n    .summary-value {\n      color: #111827;\n      font-weight: 400;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .summary-actions {\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    \n    .edit-btn {\n      padding: 0.5rem 1rem;\n      background-color: #3b82f6;\n      color: white;\n      border: none;\n      border-radius: 0.25rem;\n      font-size: 0.875rem;\n      font-weight: 500;\n      cursor: pointer;\n      white-space: nowrap;\n      transition: background-color 0.2s;\n\n      &:hover {\n        background-color: #2563eb;\n      }\n    }\n  }\n}\n\n\n// Field Layout\n.dc-field-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n}\n\n.dc-field-group {\n  margin-bottom: 1rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n// Input Styling\n.dc-input-wrapper {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.dc-label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  font-size: 0.875rem;\n  color: #374151;\n  .user-form-required {\n    color: #ef4444;\n    margin-left: 0.25rem;\n  }\n}\n\n.dc-input,\n.dc-textarea {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #d1d5db;\n  border-radius: 0.25rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: #374151;\n  background: #ffffff;\n  box-sizing: border-box;\n\n  &:focus {\n    outline: none;\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n  }\n\n  &:hover:not(:focus) {\n    border-color: #9ca3af;\n  }\n\n  &::placeholder {\n    color: #9ca3af;\n  }\n\n  &:disabled {\n    background-color: #f9fafb;\n    color: #6b7280;\n    cursor: not-allowed;\n  }\n}\n\n.dc-input {\n  height: 2.5rem;\n\n  &.dc-input-full {\n    grid-column: 1 / -1;\n  }\n\n  &.dc-input-date {\n    cursor: pointer;\n\n    &::-webkit-calendar-picker-indicator {\n      cursor: pointer;\n      opacity: 0.6;\n\n      &:hover {\n        opacity: 0.8;\n      }\n    }\n  }\n\n  // Select styling removed from here - moved below\n}\n\n// Select styling\nselect.dc-input {\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right 0.5rem center;\n  background-repeat: no-repeat;\n  background-size: 1.5rem 1.5rem;\n  padding-right: 2.5rem;\n}\n\n.dc-textarea {\n  min-height: 4rem;\n  resize: vertical;\n  line-height: 1.5;\n  font-family: inherit;\n}\n\n// Empty State\n.dc-empty-state {\n  text-align: center;\n  padding: 2rem;\n  background: #f9fafb;\n  border-radius: 0.375rem;\n  border: 2px dashed #e5e7eb;\n}\n\n.dc-empty-text {\n  color: #6b7280;\n  font-style: italic;\n  font-size: 0.875rem;\n}\n\n.dc-submit-section-form {\n  display: flex;\n  justify-content: end;\n  margin-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n  }\n\n  .submit-btn {\n    padding: 0.75rem 1rem;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    min-width: 150px;\n    margin-top: 1rem;\n    display: block;\n\n    &:hover {\n      background-color: #005a9a;\n    }\n\n    // &:active {\n    //   transform: translateY(1px);\n    // }\n\n    &:focus {\n      outline: none;\n      //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      margin-top: 1rem;\n    }\n  }\n}\n\n// Submit Section\n.dc-submit-section {\n  // display: flex;\n  // justify-content: center;\n  // margin-top: 1.5rem;\n  // border-top: 1px solid #e5e7eb;\n\n  // @media (max-width: 768px) {\n  //   flex-direction: column;\n  // }\n  position: fixed;\n  bottom: 2rem;\n  left: 87.7%;\n  transform: translateX(-145%);\n  z-index: 1000;\n\n  //transition: opacity 0.3s ease; // Added transition for smooth hiding\n  &.hidden {\n    opacity: 0;\n    pointer-events: none;\n  }\n\n  @media (max-width: 768px) {\n    bottom: 1rem;\n    left: 1rem;\n    right: 1rem;\n    transform: none;\n  }\n\n  .dc-submit-btn {\n    padding: 0.75rem 1rem;\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    border-radius: 0.25rem;\n    font-size: 1rem;\n    font-weight: 500;\n    cursor: pointer;\n    min-width: 150px;\n    margin: 1.5rem auto 0;\n    display: block;\n\n    &:hover {\n      background-color: #005a9a;\n      //box-shadow: 0 6px 20px rgba(92, 184, 92, 0.4);\n      // transform: translateY(-2px);\n    }\n\n    &:active {\n      //transform: translateY(0);\n      //box-shadow: 0 2px 8px rgba(92, 184, 92, 0.3);\n    }\n\n    &:focus {\n      outline: none;\n      //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3), 0 4px 12px rgba(92, 184, 92, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.7;\n      cursor: not-allowed;\n      transform: none;\n\n      &:hover {\n        //background-color: #5cb85c;\n        transform: none;\n        //box-shadow: 0 4px 12px rgba(92, 184, 92, 0.3);\n      }\n    }\n\n    @media (max-width: 768px) {\n      width: 100%;\n      border-radius: 25px;\n      min-width: unset;\n      font-size: 0.95rem;\n      padding: 0.875rem 1.25rem;\n    }\n  }\n}\n\n// .dc-submit-btn {\n//   padding: 1rem 1.5rem;\n//   background-color: #5cb85c;\n//   color: white;\n//   border: none;\n//   border-radius: 0.25rem;\n//   font-size: 1rem;\n//   font-weight: 500;\n//   cursor: pointer;\n//   min-width: 150px;\n//   margin: 1.5rem auto 0;\n\n//   &:hover {\n//     background-color: #16a34a;\n//   }\n\n//   &:active {\n//     transform: translateY(1px);\n//   }\n\n//   &:focus {\n//     outline: none;\n//     box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n//   }\n\n//   &:disabled {\n//     opacity: 0.6;\n//     cursor: not-allowed;\n//   }\n\n//   @media (max-width: 768px) {\n//     width: 100%;\n//   }\n// }\n\n// Responsive Design\n@media (max-width: 768px) {\n  .dc-field-row {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .dc-subsection {\n    padding: 0.75rem;\n  }\n\n  .dc-input,\n  .dc-textarea {\n    font-size: 0.875rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .dc-case-form-wrapper {\n    padding: 0.5rem;\n  }\n\n  .dc-case-form {\n    padding: 1rem;\n    margin: 0.5rem;\n  }\n\n  .dc-case-form-header .dc-case-form-title {\n    font-size: 1.125rem;\n  }\n\n  .dc-input,\n  .dc-textarea {\n    padding: 0.375rem;\n    font-size: 0.8125rem;\n  }\n\n  .dc-submit-btn {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n}\n\n// Animation for form appearance\n.dc-case-form {\n  animation: dc-fade-in 0.3s ease-out;\n}\n\n@keyframes dc-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Print styles\n@media print {\n  .dc-case-form-wrapper {\n    background: white;\n    padding: 0;\n  }\n\n  .dc-case-form {\n    box-shadow: none;\n    border: 1px solid #000;\n  }\n\n  .dc-submit-section,\n  .rem-div-btn,\n  .add-div-btn {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
